import Vue from 'vue'

export function capitalizer (s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export default {
  install () {
    Vue.prototype.$capitalize = capitalizer
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $capitalize: (string: string) => string;
  }
}